import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { searchBox, hits, refinementList, stats, pagination, sortBy, currentRefinements, configure, menuSelect } from 'instantsearch.js/es/widgets';
import { connectPagination } from 'instantsearch.js/es/connectors';
import SearchCommon from '../search-common';

export default class FullsiteSearch {
    constructor(FullsiteSearchElement) {
        this.fullsiteSearchElement = FullsiteSearchElement;
        this.searchCommon = new SearchCommon(this.fullsiteSearchElement);
    }

    init() {
        const searchClient = algoliasearch(tsAlgoliaConfig.algoliaAppId, tsAlgoliaConfig.algoliaPublicReadApikey);

        const algoliaInstantSearch = instantsearch({
            indexName: tsAlgoliaConfig.algoliaFullsiteIndexName + '_date_desc',
            searchClient,
            insights: false,
            routing: true
        });

        const customPagination = connectPagination(
            this.searchCommon.renderPagination
        );

        algoliaInstantSearch.addWidgets([
            searchBox({
                container: "#searchbox",
                placeholder: 'Search word',
                templates: {
                    reset({ cssClasses }, { html }) {
                        return html`
                          <svg class="ais-SearchBox-resetIcon" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-width="2" d="M1.293 17.293 17.556 1.029M1.707 1.293l16.264 16.263" />
                          </svg>
                        `
                    },
                    submit({ cssClasses }, { html }) {
                        return html`
                        <svg class="ais-SearchBox-submitIcon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8.66" cy="7" r="6" stroke-width="1.5" />
                          <path d="m1 15.004 3.66-3.66" stroke-width="1.5" />
                        </svg>
                        `
                    },
                }
            }),

            hits({
                container: '#hits',
                templates: {
                    item(hit, { html, components, sendEvent }) {
                        hit.primaryLinkText = hit.primaryLinkText.replace('&#38;', '&');
                        return html`
                             <li class="ais-Hits-item">
                            <article class="space-y-1.5">
                                <div class="flex flex-col md:gap-4 md:flex-row md:flex-wrap">
                                    <h3>
                                        ${hit.contentType} <a href="${hit.primaryLinkUrl}" target="${hit.primaryLinkTarget}" class="type-epsilon text-light-purple link">${hit.primaryLinkText}</a>
                                    </h3>
                                    <ul class="flex gap-2 flex-wrap">
                                        ${hit.relatedStageLinks.map(stageLink =>
                                            html`<li class="flex items-center">
                                            <a href="${stageLink.url}" class="type-zeta link underline underline-offset-4">${stageLink.name.replace('&#38;', '&')}</a>
                                            </li>`)}
                                    </ul>
                                </div>
                                <p class="type-small-paragraph">
                                    ${hit.summary}
                                </p>
                            </article>
                        </li>`;
                    }
                }
            }),

            sortBy({
                container: '#sortby',
                items: [
                    { label: 'Date (newest)', value: tsAlgoliaConfig.algoliaFullsiteIndexName + '_date_desc' },
                    { label: 'Date (oldest)', value: tsAlgoliaConfig.algoliaFullsiteIndexName+'_date_asc' },
                    { label: 'Title (Asc)', value: tsAlgoliaConfig.algoliaFullsiteIndexName+'_title_asc' },
                    { label: 'Title (Desc)', value: tsAlgoliaConfig.algoliaFullsiteIndexName+'_title_desc' },
                ],
            }),

            customPagination({
                container: document.querySelector('#pagination'),
            }),


            /*
            pagination({
                container: '#pagination',
                scrollTo: '#full-site-search',
                templates: {
                    previous(p, { html, components, sendEvent }) {
                        return html`
                          <span class="ais-Pagination-link" aria-label="Previous">
                            <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M21.1528 16.3536C21.348 16.1583 21.348 15.8417 21.1528 15.6464L17.9708 12.4645C17.7755 12.2692 17.4589 12.2692 17.2637 12.4645C17.0684 12.6597 17.0684 12.9763 17.2637 13.1716L20.0921 16L17.2637 18.8284C17.0684 19.0237 17.0684 19.3403 17.2637 19.5355C17.4589 19.7308 17.7755 19.7308 17.9708 19.5355L21.1528 16.3536ZM11.1992 16.5H20.7992V15.5L11.1992 15.5V16.5Z"
                                fill="#222628"
                              />
                            </svg>
                          </span>
                        `
                    },
                    first(f, { html, components, sendEvent }) {
                        return html``
                    },
                    last(l, { html, components, sendEvent }) {
                        return html``
                    },
                    next(n, { html, components, sendEvent }) {
                        return html`
                      <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M21.1528 16.3536C21.348 16.1583 21.348 15.8417 21.1528 15.6464L17.9708 12.4645C17.7755 12.2692 17.4589 12.2692 17.2637 12.4645C17.0684 12.6597 17.0684 12.9763 17.2637 13.1716L20.0921 16L17.2637 18.8284C17.0684 19.0237 17.0684 19.3403 17.2637 19.5355C17.4589 19.7308 17.7755 19.7308 17.9708 19.5355L21.1528 16.3536ZM11.1992 16.5H20.7992V15.5L11.1992 15.5V16.5Z"
                          fill="#222628"
                        />
                      </svg>
                        `
                    }
                }
            }),*/

            stats({
                container: '#stats',
                templates: {
                    text(data, { html }) {
                        let searchCommon = new SearchCommon();
                        return html`
                <span class="ais-Stats-text">${searchCommon.renderPageString(data.page, data.hitsPerPage, data.nbHits)}</span>
                `
                    },
                }
            }),

            currentRefinements({
                container: '#currentrefinements',
                transformItems(items) {
                    items = items.map(item => {
                        if (searchPageConfigurationParameters.contentTypesVisible) {
                            item.label = (item.label != null && item.label == 'templateName' ? 'Type' : item.label);
                        }
                        if (searchPageConfigurationParameters.stagesVisible) {
                            item.label = (item.label != null && item.label == 'relatedStages' ? 'Stage' : item.label);
                        }
                        if (searchPageConfigurationParameters.topicsVisible) {
                            item.label = (item.label != null && item.label == 'relatedTopics' ? 'Topic' : item.label);
                        }
                        return item;
                    })
                    if (!searchPageConfigurationParameters .contentTypesVisible) {
                        items = items.filter(item => item.attribute !== 'templateName');
                    }
                    if (!searchPageConfigurationParameters .stagesVisible) {
                        items = items.filter(item => item.attribute !== 'relatedStages');
                    }
                    if (!searchPageConfigurationParameters .topicsVisible) {
                        items = items.filter(item => item.attribute !== 'relatedTopics');
                    }
                    return items;
                }
            })
        ]);


        if (searchPageConfigurationParameters.contentTypesVisible) {
            algoliaInstantSearch.addWidget(menuSelect({
                container: '#menuselect-contenttype',
                attribute: 'templateName',
                templates: {
                    defaultOption(data, { html }) {
                        return html`<span>Type</span>`;
                    },
                }
            }))
        }

        if (searchPageConfigurationParameters.stagesVisible) {
            algoliaInstantSearch.addWidget(menuSelect({
                container: '#menuselect-stage',
                attribute: 'relatedStages',
                templates: {
                    defaultOption(data, { html }) {
                        return html`<span>Stage</span>`;
                    },
                }
            }))
        }

        if (searchPageConfigurationParameters.topicsVisible) {
            algoliaInstantSearch.addWidget(menuSelect({
                container: '#menuselect-topic',
                attribute: 'relatedTopics',
                templates: {
                    defaultOption(data, { html }) {
                        return html`<span>Topic</span>`;
                    },
                }
            }))
        }

        if (searchPageConfigurationParameters.preselectedContentTypes.length > 0) {
            algoliaInstantSearch.addWidget(
                configure({
                    disjunctiveFacetsRefinements: {
                        templateName: searchPageConfigurationParameters.preselectedContentTypes,
                    },
                })
            );
        }

        if (searchPageConfigurationParameters.preselectedStages.length > 0) {
            algoliaInstantSearch.addWidget(
                configure({
                    disjunctiveFacetsRefinements: {
                        relatedStages: searchPageConfigurationParameters.preselectedStages,
                    },
                })
            );
        }

        if (searchPageConfigurationParameters.preselectedTopics.length > 0) {
            algoliaInstantSearch.addWidget(
                configure({
                    disjunctiveFacetsRefinements: {
                        relatedTopics: searchPageConfigurationParameters.preselectedTopics,
                    },
                })
            );
        }

        if (searchPageConfigurationParameters.searchQuery != '') {
            algoliaInstantSearch.addWidget(
                configure({
                    query: searchPageConfigurationParameters.searchQuery
                })
            );
        }

        algoliaInstantSearch.start();
    }

}



